import request from '@/shared/api/request';

export const deleteDomain = (name: string): Promise<void> =>
  request({
    url: `/domains/${name}/`,
    method: 'DELETE',
  });
